module.exports = __webpack_public_path__ + "img/hint-around.36e45f66.svg";